import React from "react";
import { ApproveButton, RejectButton } from "../../../../../components/mui/Buttons/Buttons";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import GlobalApproval from "../../../../../components/mui/Dialogue/GlobalApproval";
import { getTrainerData } from "../../../../../redux/features/CRDslice";
import { savePaginationData } from "../../../../../redux/features/globalDatagridSlice";
import GlobalReject from "../../../../../components/mui/Dialogue/GlobalReject";
import TrainerStatusInactive from "./TrainerStatusInactive";

const TrainerApproveOrReject = ({ row,dispatchParams,activeType,crm }) => {
  const { loading } = useSelector((store) => store.crd);
      const { paginationData } = useSelector((state) => state.globalDataGrid)
    const handleAction = (status) => {
    //   const data = { id: row.food_id, status: status };
    //   dispatch(eveningFoodApproveOrRejectOrBulk(data)).then((res) => {
    //     if (res.payload.status == "failed" || res.payload.status == "error") {
    //       enqueueSnackbar(`${res.payload.message}`, { variant: "error" });
    //     } else {
    //       dispatch(allEveningFoodRequests(row.food_date));
    //       enqueueSnackbar(`${res.payload.message}`, { variant: "success" });
    //     }
    //   });
    };
  return (
    <Box>
       <TrainerStatusInactive activeType={activeType} row={row} dispatchParams={dispatchParams} crm={crm}/>
    </Box>

    
  );
};

export default TrainerApproveOrReject;
